/* -------------- Common -------------- */
export const cultures = ["tr-TR", "en-US"] as const;

// The backend's limit for a tag name (EventTagValidator, nvarchar(50)); sent as JSON.
export const EventTagRules = {
	tagNameMaxLength: 50,
} as const;

export interface ApiResponse<T> {
    result: T;
    error: { code?: number; message?: string } | string | null;
    isSuccessful: boolean;
}

export interface ListResult<T> {
    items: T[];
}

export type OperationStatus =
    | { type: "idle" }
    | { type: "loading"; operation: "add" | "fetch" | "update" | "delete" | "export" }
    | { type: "error"; operation: string; message: string };

// -------------- LIST (response) --------------
export interface EventTagListItem {
    eventTagId: string;
    tagIcon: string;
    tagName: string;
    isBeingUsed: boolean;
    creationDate?: string | null;
}

export type EventTagListApiResponse = ApiResponse<ListResult<EventTagListItem>>;

// -------------- GET (response) --------------
export interface EventTagLocalizable {
    eventTagLocalizableId: string;
    culture: string;
    tagName: string;
}

export interface EventTagDetail {
    eventTagId: string;
    tagIcon: string;
    eventTagLocalizable: EventTagLocalizable[];
}

export type EventTagGetApiResponse = ApiResponse<EventTagDetail>;

// -------------- ADD (form = request) --------------
export interface AddEventTagLocalizable {
    culture: string;
    tagName: string;
}

export interface AddEventTagFormData {
    tagIcon: string;
    eventTagLocalizable: AddEventTagLocalizable[];
}

export const defaultAddEventTagFormData: AddEventTagFormData = {
	tagIcon: "",
	eventTagLocalizable: cultures.map(culture => ({ culture, tagName: "" })),
};

// -------------- EDIT (form state, complete) --------------
export type EditEventTagFormData = EventTagDetail;

// -------------- UPDATE (PATCH request, partial) --------------
export interface UpdateEventTagLocalizable {
    eventTagLocalizableId: string;
    culture: string;
    tagName?: string; 
}

export interface UpdateEventTagRequest {
    eventTagId: string;
    tagIcon?: string;
    eventTagLocalizable?: UpdateEventTagLocalizable[];
}